import { CaseStudiesDocument, CaseStudiesQuery } from 'graphql/generated';

import CaseStudyItem from 'components/CaseStudyItem';
import ContentBoxNew from 'components/ContentBoxNew';
import DatoMeta from 'components/DatoMeta';
import Footer from 'components/Footer';
import Navigation from 'components/Navigation';
import RootContainer from 'components/RootContainer';
import Typography from 'components/Typography';

import { datoRequest } from 'lib/datoSDK';

import * as S from 'styles/CaseStudies.styles';

interface ICaseStudiesProps {
  caseStudiesQuery: CaseStudiesQuery;
}

const CaseStudies = ({ caseStudiesQuery }: ICaseStudiesProps) => {
  const page = caseStudiesQuery.caseStudiesPage;
  const caseStudies = caseStudiesQuery.allCaseStudies;
  const allNavitems = caseStudiesQuery.allNavitems;

  return (
    <>
      {page?.seo && <DatoMeta seo={page?.seo} />}

      <Navigation navItems={allNavitems} />
      <RootContainer>
        <ContentBoxNew>
          <Typography.h1>{page?.title}</Typography.h1>

          {/* TODO: Move to a component that renders DatoCMS markdown */}
          {page?.subtitle && <div dangerouslySetInnerHTML={{ __html: page?.subtitle }} />}
        </ContentBoxNew>

        <S.CaseStudiesGrid>
          {caseStudies.map((caseStudy, i) => (
            <CaseStudyItem caseStudy={caseStudy} key={i} />
          ))}
        </S.CaseStudiesGrid>
      </RootContainer>
      <Footer />
    </>
  );
};

export const getStaticProps = async () => {
  const caseStudiesQuery = await datoRequest<CaseStudiesQuery>(CaseStudiesDocument);

  return {
    props: { caseStudiesQuery },
    revalidate: 1
  };
};

export default CaseStudies;
